import { memberProgram } from "../../services";
import { trackEvent } from "../../services/analytics";
import { GET_COMPLETED_PROGRAMS, GET_CURRENT_PROGRAM_DAY, GET_PROGRAMS, MODAL_EVERY_FOUR_DAYS, USER_LOADED, USER_LOADING } from "../types";
import { updateCurrentUser } from "./authActions";

export const getPrograms =
  ({ currentPrograms, completedPrograms, currentProgramDay }) =>
  dispatch => {
    dispatch({ type: GET_PROGRAMS, payload: currentPrograms });
    dispatch({ type: GET_COMPLETED_PROGRAMS, payload: completedPrograms });
    dispatch({ type: GET_CURRENT_PROGRAM_DAY, payload: currentProgramDay });
  };

export const markAsCompleteProgram = (programSlug, day, isPreventionProgram) => async dispatch => {
  dispatch({ type: USER_LOADING });
  try {
    trackEvent("Web.MSK.MarkDayAsComplete", { programReference: programSlug, day });
    const body = { dayCompleted: day.title };
    if (isPreventionProgram) {
      body["id"] = day.id;
    }
    await memberProgram.put(programSlug, body);
    await dispatch(updateCurrentUser());
  } catch {
    dispatch({ type: USER_LOADED });
  }
};

export const setShowEveryFourModal = (show: boolean, currentDayIndex?: number) => {
  return {
    type: MODAL_EVERY_FOUR_DAYS,
    payload: {
      show,
      currentDayIndex,
    },
  };
};
